// import qs from 'qs';
/**
 * 获取地址栏参数
 * @param {String} [name] (相当于key)
 * @return {String} (相当于value)
 */
const getQuery = name => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let str = window.location.href.split('?')[1];
  if (!str) {
    return null;
  }
  let r = str.match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
};
/**
 * 获取地址栏所有参数
 * @return {Object}
 */
const getQueryToObj = () => {
  let str = window.location.href.split('?')[1];
  return str ? qs.parse(str) : {};
};
/**
 * 获取地址链接域名
 * @param {String} [url]
 * @return {String}
 */
const getUrlDomain = url => {
  if (typeof url !== 'string' || url === '') {
    return '';
  }
  let reg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
  let domain = url.match(reg)[0];
  return domain;
};

export { getQuery, getQueryToObj, getUrlDomain };
